import { call, select, takeLatest } from 'redux-saga/effects'

import managers from '../../lib/managers'
import PaperManager from '../../lib/managers/PaperManager'
import { Workspace } from '../../lib/toolBoxes/2D'
import { selectSelectedItem, updateSelectedPaperId } from '../../slices/2D'

export function* handleLockCanvasElements() {
    const manager: PaperManager | null = yield call(managers.get2DManager)

    if (!manager) return

    const [workspaceTool]: [Workspace] = yield call(manager.getTools, [Workspace.NAME])

    const selectedElementPaperId = yield select(selectSelectedItem)

    if (selectedElementPaperId) {
        const item: paper.Item[] = yield call(workspaceTool.getItemsWithCriteria, 'id', (id) => {
            return id === selectedElementPaperId
        })

        if (!item?.[0]) return

        yield call(workspaceTool.lockItems, true, [item[0].data.drawable_id])
    } else {
        yield call(workspaceTool.lockItems, false)
    }
}

export function* watchForCanvasElementsLocking() {
    yield takeLatest(updateSelectedPaperId.type, handleLockCanvasElements)
}
